/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/12/7
 * @updateTime 2021/12/7
 * @decription 表单操作混入js
 */
import {formatMoney} from "@/utils/common";
import {columnsDBFS, columnsDycclx} from "@/utils/option";
import {mbxzts} from "@/utils/consts";
// 表单布局
import acLayoutForm from '@/components/app/layout/form/index.vue';
// 上传文件
import acUploadFile from '@/components/app/upload-file/index.vue';
import {bdhRule, bxgsRule, cclxRule, cDbrRule, dbfsRule, DbjzRule, dBwmcRule} from "@/utils/validator/rules";
// 请求js
import request from './request.js';
export default {
    mixins: [request],
    components: {
        acLayoutForm,
        acUploadFile
    },
    // 参数
    props: {
        // 编辑数据
        data: Object,
        // 担保机构数据列表
        dataList: Array,
        // 保全id
        bqid: String,
        // 资源信息，申请人
        source: Object
    },
    // 数据
    data() {
        return {
            // 申请人姓名
            sqr: '',
            // 补充担保原因大小
            fieldSize: {
                maxHeight: 80,
                minHeight: 80
            },
            //担保机构弹层
            showPickerBxgs: false,
            // 担保机构数据
            columnsBxgs: this.dataList,
            // 保单号弹层
            showPickerBdh: false,
            // 保单号
            columnsBdh: [],
            // 担保方式
            // columnsDBFS: columnsDBFS,
            columnsDBFS: [],
            // 担保方式选择器
            showPickerDbfs: false,
            // 抵押财产类型
            showPickerDycclx: false,
            // 抵押财产类型代码值
            columnsDycclx: columnsDycclx,
            // 模板下载地址
            mbxzts: mbxzts,
            // 文件上传url地址
            uploadFileUrl: 'ssbq/api/sccls/bgdb/sccl',
            // 删除文件请求url地址
            deleteFileUrl: 'ssbq/api/sccls/bgsq/bg/delsccl'
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 创建完成
        // 行为保全和证据保全担保方式不显示【保险公司诉责险】
        let cBqlx = sessionStorage.getItem('cBqlx');
        let cBqlb = sessionStorage.getItem('cBqlb');
        if (cBqlx === '1' && cBqlb !== '4') {
            this.formData.cDbfs = '5';
            this.formData.nSysbuy = 1;
            this.columnsDBFS = columnsDBFS;
        } else {
            this.formData.cDbfs = '1';
            this.formData.nSysbuy = null;
            this.columnsDBFS = columnsDBFS.filter(item => item.keyId !== '5');
            this.formData.dbfsText=columnsDBFS.filter(item=>item.keyId==='1')[0].text;
        }
    },
    // 组件激活
    activated() {
        // 激活完成
    },
    // 组件初始化完成
    mounted() {
        // 初始化完成
    },
    // 组件失去激活
    deactivated() {
        // 失去激活
    },
    // 销毁之前
    beforeDestroy() {
        // 销毁之前
    },
    // 方法
    methods: {

        /**
         * 格式化担保价值
         * @param {String} value
         * @returns {void}
         * */
        formatDbjz(value) {
            // 担保价值显示文本
            this.formData.nDbjzText = formatMoney(value);
            // 担保价值
            this.formData.nDbjz = this.formData.nDbjzText.toString().replace(/,|，/g, '');
        },

        /**
         * 修改了保险公司诉责险类型
         * @returns {void}
         * */
        onChangeSysBuys() {
            // 删除对应的材料
            this.deleteFiles();
            this.formData = {
                ...this.formData,
                // 诉责险id置空
                cSzxid: '',
                // 担保机构置空
                cBxgs: '',
                // 担保机构名称置空
                cBxgsmc: '',
                // 保单号置空
                cBdh: '',
                // 担保价值
                nDbjz: '',
                // 担保价值文本
                nDbjzText: '',
                // 担保人
                cDbr: '',
                // 担保说明
                cDbsm: ''
            };
        },

        /**
         * 确认担保机构名称
         * @param {Object} item 选中的担保机构信息项
         * @returns {void}
         * */
        onConfirmBxgs(item) {
            // 赋值担保机构数据
            this.formData.cBxgsmc = item.name;
            this.formData.cBxgs = item.id;
            this.showPickerBxgs = false;
            // 赋值保单号数据
            this.columnsBdh = item.dbJbxxs;
            // 清空对应的保单号
            this.formData.cBdh = '';
        },

        /**
         * 确认保单号
         * @param {Object} item 选中的保单号信息项
         * @returns {void}
         * */
        onConfirmBdh: function (item) {
            // 赋值对应的诉责险id
            this.formData.cSzxid = item.cLy || item.cId;
            // 保单号赋值
            this.formData.cBdh = item.cBdh;
            // 格式化担保价值
            this.formatDbjz(item.nDbjz);
            this.showPickerBdh = false;
        },

        /**
         * 选择了担保方式
         * @param {Object} item 选择的信息项数据
         * @returns {void}
         * */
        onConfirmDbfs: function (item) {
            // 删除对应的材料
            this.deleteFiles();
            this.formData = {
                ...this.formData,
                // 担保方式文本赋值
                dbfsText: item.text,
                // 担保方式值赋值
                cDbfs: item.keyId,
                // 担保机构置空
                cBxgs: '',
                // 担保机构名称置空
                cBxgsmc: '',
                // 保单号置空
                cBdh: '',
                // 担保价值
                nDbjz: '',
                // 担保价值文本
                nDbjzText: '',
                // 担保人
                cDbr: '',
                // 担保说明
                cDbsm: '',
                // 担保物名称
                cDbwmc: '',
                // 抵押/质押财产类型,
                cCclx: '',
                // 财产类型文字描述
                cCclxText: '',
                // 是否系统自动关联
                nSysbuy: item.keyId === '5' ? 1 : null
            };
            // 隐藏担保方式选择器
            this.showPickerDbfs = false;
        },

        /**
         * 抵押财产类型
         * @param {Object} item 选择的信息项数据
         * @returns {void}
         * */
        onConfirmDycclx: function (item) {
            this.formData.cCclxText = item.text;
            this.formData.cCclx = item.keyId;
            this.showPickerDycclx = false
        },
        /**
         * 点击取消
         * @returns {void}
         * */
        eClickCancel() {
            // 分发取消事件
            this.$emit('cancel', this.formData);
        },

        /**
         * 点击确认按钮
         * @returns {void}
         * */
        onBtnConfirm: function () {
            const validated = this.validateFormDate();
            validated.then(() => {
                this.submitDBXX();
            })
                .catch(error => {
                    console.log('校验未通过:', error);
                });
        },

        /**
         * 将信息提交到父级组件
         */
        submitDBXX: function () {
            // 进行保存
            this.$emit('submit', this.formData);
        },

        /**
         * 公共的组装表单数据
         * @param {Object} data
         * @returns {void}
         * */
        commonAssembleFormData(data = null) {
            // 组装的数据
            let _data = data || this.data;
            // 将data数据赋值给表单数据
            this.formData = {
                ...this.formData,
                ..._data
            };
            // 担保价值格式化
            this.formData.nDbjzText = formatMoney(this.formData.nDbjz);
            // 如果是保险公司诉责险，并且是自动关联的担保信息，则需要初始化保单号
            if (_data.cDbfs === '5' && _data.nSysbuy === 1) {
                this.dataList.some(dataItem => {
                    if (dataItem.id === _data.cBxgs) {
                        this.columnsBdh = dataItem.dbJbxxs;
                        return true;
                    }
                    return false;
                });
            }
        },

        /**
         * 处理公共的表单验证
         * @param {Object} descriptor 验证描述对象
         * @returns {void}
         * */
        commonValidateForm(descriptor) {
            // 担保方式校验
            descriptor.cDbfs = dbfsRule;
            // 针对担保方式进行校验
            switch (String(this.formData.cDbfs)) {
                case '1':
                    // 交纳保证金
                    break;
                case '2':
                    // 提供保证人
                    // 担保人
                    descriptor.cDbr = cDbrRule;
                    // 担保物
                    descriptor.cDbwmc = dBwmcRule;
                    break;
                case '3':
                case '4':
                    // 设定抵押/质押
                    // 财产类型
                    descriptor.cCclx = cclxRule;
                    break;
                case '5':
                    // 保险公司诉责险
                    descriptor.cBxgsmc = bxgsRule;
                    // 系统自动关联
                    if (this.formData.nSysbuy === 1) {
                        // 保单号进行校验
                        descriptor.cBdh = bdhRule;
                    }
                    break;
            }
            // 担保价值
            descriptor.nDbjz = new DbjzRule(true);
        }
    }
};
